import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  useMemo,
} from "react";
import Icons from "../utils/components/icons";
import "./userPreferences.scss";
import { getDetailsForUser } from "../services/UserService";
import { setNotificationPreference } from "../services/EventsNotifications";
import { useTranslation } from "react-i18next";
import { UserContext } from "./MainLayout";
import LoadingSpinner from "../utils/components/common/loadingSpinner/LoadingSpinner";
import EmptyScreen from "../utils/components/common/EmptyScreen/EmptyScreen";

const UserPreferences = () => {
  const { userCognitoData } = useContext(UserContext);

  const [isPushNotificationActive, setIsPushNotificationActive] =
    useState(true);
  const [isPrivacyActive, setIsPrivacyActive] = useState(false);
  const [isUnitActive, setIsUnitActive] = useState(false);
  const [isCartridgeOpen, setIsCartridgeOpen] = useState(false);
  const [isPPBOpen, setIsPPBOpen] = useState(false);
  const [isFaultOpen, setIsFaultOpen] = useState(false);
  const [isConnectivityOpen, setIsConnectivityOpen] = useState(false);
  const [isDeviceOpen, setIsDeviceOpen] = useState(false);
  const [cartridgeEmpty, setCartridgeEmpty] = useState(true);
  const [cartridgeError, setCartridgeError] = useState(true);
  const [cartridgeLow, setCartridgeLow] = useState(true);
  const [cartridgeReplaced, setCartridgeReplaced] = useState(true);
  const [changeLocation, setChangeLocation] = useState(true);
  const [changeMode, setChangeMode] = useState(true);
  const [changeModeFailure, setChangeModeFailure] = useState(true);
  const [changeName, setChangeName] = useState(true);
  const [connectivityRestored, setConnectivityRestored] = useState(true);
  const [deviceOffline, setDeviceOffline] = useState(true);
  const [faultPPBAbove130, setFaultPPBAbove130] = useState(true);
  const [faultPPBAbove150, setFaultPPBAbove150] = useState(true);
  const [offlineFor30Minutes, setOfflineFor30Minutes] = useState(true);
  const [ppbAbove130, setPpbAbove130] = useState(true);
  const [ppbAbove150, setPpbAbove150] = useState(true);
  const [ppbBelow70, setPpbBelow70] = useState(true);
  const [ppbWithinLimits, setPpbWithinLimits] = useState(true);
  const [sensorPanelError, setSensorPanelError] = useState(true);
  const [sensorPanelReplacement, setSensorPanelReplacement] = useState(true);
  const [userData, setUserData] = useState([]);
  const [dataChecker, setDataChecker] = useState(false);
  const [err, setErr] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation("header");

  const CognitoUserID = useMemo(() => {
    return userCognitoData?.signInUserSession?.accessToken?.payload?.username;
  }, [userCognitoData]);

  const handleActiveContainer = (checker) => {
    if (checker === "push") {
      setIsPushNotificationActive(true);
      setIsPrivacyActive(false);
      setIsUnitActive(false);
    } else if (checker === "privacy") {
      setIsPrivacyActive(true);
      setIsPushNotificationActive(false);
      setIsUnitActive(false);
    } else {
      setIsUnitActive(true);
      setIsPushNotificationActive(false);
      setIsPrivacyActive(false);
    }
  };

  const getUserDetail = useCallback(async () => {
    if (CognitoUserID) {
      try {
        setErr(false);
        setIsLoading(true);
        const queryParam = {
          cognitoId: CognitoUserID,
        };
        const response = await getDetailsForUser(queryParam);
        setUserData(response?.data?.UserDetails);
        setIsLoading(false);
      } catch (error) {
        setErr(true);
        setIsLoading(false);
      }
    }
  }, [CognitoUserID]);

  useEffect(() => {
    getUserDetail();
  }, [getUserDetail]);

  useEffect(() => {
    if (Object.keys(userData).length > 1) {
      if (userData.NotificationPreferences) {
        setCartridgeEmpty(userData.NotificationPreferences.CartridgeEmpty);
        setCartridgeError(userData.NotificationPreferences.CartridgeError);
        setCartridgeLow(userData.NotificationPreferences.CartridgeLow);
        setCartridgeReplaced(
          userData.NotificationPreferences.CartridgeReplaced
        );
        setChangeLocation(userData.NotificationPreferences.ChangeLocation);
        setChangeMode(userData.NotificationPreferences.ChangeMode);
        setChangeModeFailure(
          userData.NotificationPreferences.ChangeModeFailure
        );
        setChangeName(userData.NotificationPreferences.ChangeName);
        setConnectivityRestored(
          userData.NotificationPreferences.ConnectivityRestored
        );
        setDeviceOffline(userData.NotificationPreferences.DeviceOffline);
        setFaultPPBAbove130(userData.NotificationPreferences.FaultPPBAbove130);
        setFaultPPBAbove150(userData.NotificationPreferences.FaultPPBAbove150);
        setOfflineFor30Minutes(
          userData.NotificationPreferences.OfflineFor30Minutes
        );
        setPpbAbove130(userData.NotificationPreferences.PPBAbove130);
        setPpbAbove150(userData.NotificationPreferences.PPBAbove150);
        setPpbBelow70(userData.NotificationPreferences.PPBBelow70);
        setPpbWithinLimits(userData.NotificationPreferences.PPBWithinLimits);
        setSensorPanelError(userData.NotificationPreferences.SensorPanelError);
        setSensorPanelReplacement(
          userData.NotificationPreferences.SensorPanelReplacement
        );
      }
      setDataChecker(true);
    }
  }, [userData]);

  const [onChangeChecker, setOnChangeChecker] = useState(false);

  const handleClick = (eventName) => {
    switch (eventName) {
      case "cartridgeEmpty":
        setCartridgeEmpty(!cartridgeEmpty);
        setOnChangeChecker(true);

        break;
      case "cartridgeError":
        setCartridgeError(!cartridgeError);
        setOnChangeChecker(true);

        break;
      case "cartridgeLow":
        setCartridgeLow(!cartridgeLow);
        setOnChangeChecker(true);

        break;
      case "cartridgeReplaced":
        setCartridgeReplaced(!cartridgeReplaced);
        setOnChangeChecker(true);

        break;
      case "changeLocation":
        setChangeLocation(!changeLocation);
        setOnChangeChecker(true);

        break;
      case "changeMode":
        setChangeMode(!changeMode);
        setOnChangeChecker(true);

        break;
      case "changeModeFailure":
        setChangeModeFailure(!changeModeFailure);
        setOnChangeChecker(true);

        break;
      case "changeName":
        setChangeName(!changeName);
        setOnChangeChecker(true);

        break;
      case "connectivityRestored":
        setConnectivityRestored(!connectivityRestored);
        setOnChangeChecker(true);

        break;
      case "deviceOffline":
        setDeviceOffline(!deviceOffline);
        setOnChangeChecker(true);

        break;

      case "faultPPBAbove130":
        setFaultPPBAbove130(!faultPPBAbove130);
        setOnChangeChecker(true);

        break;
      case "faultPPBAbove150":
        setFaultPPBAbove150(!faultPPBAbove150);
        setOnChangeChecker(true);

        break;
      case "offlineFor30Minutes":
        setOfflineFor30Minutes(!offlineFor30Minutes);
        setOnChangeChecker(true);

        break;
      case "ppbAbove130":
        setPpbAbove130(!ppbAbove130);
        setOnChangeChecker(true);

        break;
      case "ppbAbove150":
        setPpbAbove150(!ppbAbove150);
        setOnChangeChecker(true);

        break;
      case "ppbBelow70":
        setPpbBelow70(!ppbBelow70);
        setOnChangeChecker(true);

        break;
      case "ppbWithinLimits":
        setPpbWithinLimits(!ppbWithinLimits);
        setOnChangeChecker(true);

        break;
      case "sensorPanelError":
        setSensorPanelError(!sensorPanelError);
        setOnChangeChecker(true);

        break;
      case "sensorPanelReplacement":
        setSensorPanelReplacement(!sensorPanelReplacement);
        setOnChangeChecker(true);

        break;

      default:
        break;
    }
  };

  const updateNotificationDetails = async (cognitoDetail) => {
    const queryParam = {
      userID: CognitoUserID,
      notificationPreferneces: {
        Duration: 24,
        CartridgeLow: { cartridgeLow }.cartridgeLow,
        CartridgeReplaced: { cartridgeReplaced }.cartridgeReplaced,
        CartridgeEmpty: { cartridgeEmpty }.cartridgeEmpty,
        PPBWithinLimits: { ppbWithinLimits }.ppbWithinLimits,
        PPBBelow70: { ppbBelow70 }.ppbBelow70,
        OfflineFor30Minutes: { offlineFor30Minutes }.offlineFor30Minutes,
        DeviceOffline: { deviceOffline }.deviceOffline,
        ConnectivityRestored: { connectivityRestored }.connectivityRestored,
        ChangeName: { changeName }.changeName,
        ChangeLocation: { changeLocation }.changeLocation,
        SensorPanelReplacement: { sensorPanelReplacement }
          .sensorPanelReplacement,
        ChangeMode: { changeMode }.changeMode,
        ChangeModeFailure: { changeModeFailure }.changeModeFailure,
        CartridgeError: { cartridgeError }.cartridgeError,
        SensorPanelError: { sensorPanelError }.sensorPanelError,
      },
    };
    setNotificationPreference(queryParam)
      .then((response) => {
        // console.log(response);
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  useEffect(() => {
    if (onChangeChecker) {
      // console.log("onChangeChecker", onChangeChecker);
      updateNotificationDetails();
    }
  }, [
    updateNotificationDetails,

    isCartridgeOpen,

    isPPBOpen,

    isFaultOpen,

    isConnectivityOpen,

    isDeviceOpen,

    cartridgeEmpty,

    cartridgeError,

    cartridgeLow,

    cartridgeReplaced,

    changeLocation,

    changeMode,

    changeModeFailure,

    changeName,

    connectivityRestored,

    deviceOffline,

    faultPPBAbove150,

    offlineFor30Minutes,

    ppbAbove130,

    ppbAbove150,

    ppbBelow70,

    ppbWithinLimits,

    sensorPanelError,

    sensorPanelReplacement,
  ]);

  return (
    <div className="userPreferencesModalContainer">
      <div className="userPreferencesContainer">
        <div className="rightSection">
          {isPushNotificationActive && (
            <>
              {dataChecker && (
                <div className="pushNotificationContainer">
                  <div className="header">
                    <div className="heading">
                      {t("configurePushNotifications")}
                    </div>
                    <span className="description">{t("description")}</span>
                  </div>

                  <div className="mainBody">
                    <div className="collapseContainer">
                      <div className="collapseContainerWithArrows">
                        <div
                          className="collapseContainerWithArrowIcons"
                          onClick={() => setIsCartridgeOpen(!isCartridgeOpen)}
                        >
                          <button
                            type="button"
                            onClick={() => setIsCartridgeOpen(!isCartridgeOpen)}
                            aria-controls="collapse-div"
                            aria-expanded={isCartridgeOpen}
                          >
                            <div className="eventTypeContainer">
                              <div id="cartridge">
                                <span>{t("cartridge")}</span>
                              </div>
                            </div>
                          </button>
                          {isCartridgeOpen ? (
                            <span className="collapseDivArrowIcon">
                              {Icons.chevronUpArrowIcon}
                            </span>
                          ) : (
                            <span className="collapseDivArrowIcon">
                              {Icons.downArrowOutlineIcon}
                            </span>
                          )}
                        </div>
                        {isCartridgeOpen && (
                          <div className="collapse-div">
                            <div className="checkbox">
                              <label>
                                <span id="cartridgeLow">
                                  {t("cartridgeLow")}
                                </span>
                                <input
                                  type="checkbox"
                                  name="sites"
                                  value="CartridgeLow"
                                  id="flexCheckDefault"
                                  checked={cartridgeLow}
                                  onChange={""}
                                  onClick={() => handleClick("cartridgeLow")}
                                />
                                <span className="checkbox-icon-wrapper">
                                  <span className="checkbox-icon">
                                    {Icons.purpleTickCheckedBox}
                                  </span>
                                </span>
                              </label>
                            </div>
                            <div className="checkbox">
                              <label>
                                <span id="cartridgeEmpty">
                                  {t("cartridgeEmpty")}
                                </span>
                                <input
                                  type="checkbox"
                                  name="sites"
                                  value="CartridgeEmpty"
                                  id="flexCheckDefault"
                                  checked={cartridgeEmpty}
                                  onChange={""}
                                  onClick={() => handleClick("cartridgeEmpty")}
                                />
                                <span className="checkbox-icon-wrapper">
                                  <span className="checkbox-icon">
                                    {Icons.purpleTickCheckedBox}
                                  </span>
                                </span>
                              </label>
                            </div>
                            <div className="checkbox">
                              <label>
                                <span id="cartridgeReplaced">
                                  {t("cartridgeReplaced")}
                                </span>
                                <input
                                  type="checkbox"
                                  name="sites"
                                  value="CartridgeReplaced"
                                  id="flexCheckDefault"
                                  checked={cartridgeReplaced}
                                  onChange={""}
                                  onClick={() =>
                                    handleClick("cartridgeReplaced")
                                  }
                                />
                                <span className="checkbox-icon-wrapper">
                                  <span className="checkbox-icon">
                                    {Icons.purpleTickCheckedBox}
                                  </span>
                                </span>
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="collapseContainer">
                      <div
                        className="collapseContainerWithArrowIcons"
                        onClick={() => setIsPPBOpen(!isPPBOpen)}
                      >
                        <button
                          type="button"
                          onClick={() => setIsPPBOpen(!isPPBOpen)}
                          aria-controls="collapse-div"
                          aria-expanded={isPPBOpen}
                        >
                          <div className="eventTypeContainer">
                            <div id="PPBLevel">
                              <span>{t("PPBLevel")}</span>
                            </div>
                          </div>
                        </button>
                        {isPPBOpen ? (
                          <span className="collapseDivArrowIcon">
                            {Icons.chevronUpArrowIcon}
                          </span>
                        ) : (
                          <span className="collapseDivArrowIcon">
                            {Icons.downArrowOutlineIcon}
                          </span>
                        )}
                      </div>

                      {isPPBOpen && (
                        <div className="collapse-div">
                          <div className="checkbox">
                            <label>
                              <span id="PPBAbove130">{t("PPBAbove130")}</span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="PPBAbove130"
                                id="flexCheckDefault"
                                checked={true}
                                readOnly
                              />
                              <span className="checkbox-icon-wrapper checkbox-disabled">
                                <span className="checkbox-icon">
                                  {Icons.disabledGrayedTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="PPBAbove150">{t("PPBAbove150")}</span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="PPBAbove150"
                                id="flexCheckDefault"
                                checked={true}
                                readOnly
                              />
                              <span className="checkbox-icon-wrapper checkbox-disabled">
                                <span className="checkbox-icon">
                                  {Icons.disabledGrayedTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="PPBBelow70">{t("PPBBelow70")}</span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="PPBBelow70"
                                checked={ppbBelow70}
                                onChange={""}
                                onClick={() => handleClick("ppbBelow70")}
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="PPBWithinLimits">
                                {t("PPBWithinLimits")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="PPBWithinLimits"
                                id="flexCheckDefault"
                                checked={ppbWithinLimits}
                                onChange={""}
                                onClick={() => handleClick("ppbWithinLimits")}
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="collapseContainer">
                      <div
                        className="collapseContainerWithArrowIcons"
                        onClick={() => setIsFaultOpen(!isFaultOpen)}
                      >
                        <button
                          type="button"
                          onClick={() => setIsFaultOpen(!isFaultOpen)}
                          aria-controls="collapse-div"
                          aria-expanded={isFaultOpen}
                        >
                          <div className="eventTypeContainer">
                            <div id="fault">
                              <span>{t("fault")}</span>
                            </div>
                          </div>
                        </button>

                        {isFaultOpen ? (
                          <span className="collapseDivArrowIcon">
                            {Icons.chevronUpArrowIcon}
                          </span>
                        ) : (
                          <span className="collapseDivArrowIcon">
                            {Icons.downArrowOutlineIcon}
                          </span>
                        )}
                      </div>

                      {isFaultOpen && (
                        <div className="collapse-div">
                          <div className="checkbox">
                            <label>
                              <span id="faultPPBAbove130">
                                {t("faultPPBAbove130")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="ChorusFloridaHQ"
                                id="flexCheckDefault"
                                checked={true}
                                readOnly
                              />
                              <span className="checkbox-icon-wrapper checkbox-disabled">
                                <span className="checkbox-icon">
                                  {Icons.disabledGrayedTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="faultPPBAbove150">
                                {t("faultPPBAbove150")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="ChorusFloridaHQ"
                                id="flexCheckDefault"
                                checked={true}
                                readOnly
                              />
                              <span className="checkbox-icon-wrapper checkbox-disabled">
                                <span className="checkbox-icon">
                                  {Icons.disabledGrayedTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="collapseContainer">
                      <div
                        className="collapseContainerWithArrowIcons"
                        onClick={() =>
                          setIsConnectivityOpen(!isConnectivityOpen)
                        }
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setIsConnectivityOpen(!isConnectivityOpen)
                          }
                          aria-controls="collapse-div"
                          aria-expanded={isConnectivityOpen}
                        >
                          <div className="eventTypeContainer">
                            <div id="connectivity">
                              <span>{t("connectivity")}</span>
                            </div>
                          </div>
                        </button>
                        {isConnectivityOpen ? (
                          <span className="collapseDivArrowIcon">
                            {Icons.chevronUpArrowIcon}
                          </span>
                        ) : (
                          <span className="collapseDivArrowIcon">
                            {Icons.downArrowOutlineIcon}
                          </span>
                        )}
                      </div>
                      {isConnectivityOpen && (
                        <div className="collapse-div">
                          <div className="checkbox">
                            <label>
                              <span id="OfflineFor30Min">
                                {t("offlineFor30Min")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="OfflineFor30Minutes"
                                id="flexCheckDefault"
                                checked={offlineFor30Minutes}
                                onChange={""}
                                onClick={() =>
                                  handleClick("offlineFor30Minutes")
                                }
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="DeviceOffline">
                                {t("deviceOffline")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="DeviceOffline"
                                id="flexCheckDefault"
                                checked={deviceOffline}
                                onChange={""}
                                onClick={() => handleClick("deviceOffline")}
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="connectivityRestored">
                                {t("connectivityRestored")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="ConnectivityRestored"
                                id="flexCheckDefault"
                                checked={connectivityRestored}
                                onChange={""}
                                onClick={() =>
                                  handleClick("connectivityRestored")
                                }
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="collapseContainer">
                      <div
                        className="collapseContainerWithArrowIcons"
                        onClick={() => setIsDeviceOpen(!isDeviceOpen)}
                      >
                        <button
                          type="button"
                          onClick={() => setIsDeviceOpen(!isDeviceOpen)}
                          aria-controls="collapse-div"
                          aria-expanded={isDeviceOpen}
                        >
                          <div className="eventTypeContainer">
                            <div id="deviceEvents">
                              <span>{t("deviceEvents")}</span>
                            </div>
                          </div>
                        </button>
                        {isDeviceOpen ? (
                          <span className="collapseDivArrowIcon">
                            {Icons.chevronUpArrowIcon}
                          </span>
                        ) : (
                          <span className="collapseDivArrowIcon">
                            {Icons.downArrowOutlineIcon}
                          </span>
                        )}
                      </div>
                      {isDeviceOpen && (
                        <div className="collapse-div">
                          <div className="checkbox">
                            <label>
                              <span id="nameChanged">{t("nameChanged")}</span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="ChangeName"
                                id="flexCheckDefault"
                                checked={changeName}
                                onChange={""}
                                onClick={() => handleClick("changeName")}
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="locationChanged">
                                {t("locationChanged")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="ChangeLocation"
                                id="flexCheckDefault"
                                checked={changeLocation}
                                onChange={""}
                                onClick={() => handleClick("changeLocation")}
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="modeChanged">{t("modeChanged")}</span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="ChangeMode"
                                id="flexCheckDefault"
                                checked={changeMode}
                                onChange={""}
                                onClick={() => handleClick("changeMode")}
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="changeModeFailure">
                                {t("changeModeFailure")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="ChangeModeFailure"
                                id="flexCheckDefault"
                                checked={changeModeFailure}
                                onChange={""}
                                onClick={() => handleClick("changeModeFailure")}
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="sensorPanelReplaced">
                                {t("sensorPanelReplaced")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="SensorPanelReplacement"
                                id="flexCheckDefault"
                                checked={sensorPanelReplacement}
                                onChange={""}
                                onClick={() =>
                                  handleClick("sensorPanelReplacement")
                                }
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="sensorPanelError">
                                {t("sensorPanelError")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="SensorPanelError"
                                id="flexCheckDefault"
                                checked={sensorPanelError}
                                onChange={""}
                                onClick={() => handleClick("sensorPanelError")}
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="checkbox">
                            <label>
                              <span id="cartridgeError">
                                {t("cartridgeError")}
                              </span>
                              <input
                                type="checkbox"
                                name="sites"
                                value="CartridgeError"
                                id="flexCheckDefault"
                                checked={cartridgeError}
                                onChange={""}
                                onClick={() => handleClick("cartridgeError")}
                              />
                              <span className="checkbox-icon-wrapper">
                                <span className="checkbox-icon">
                                  {Icons.purpleTickCheckedBox}
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {isLoading && <LoadingSpinner />}
      {err && !isLoading && (
        <>
          <div className="header p-b-25">
            <div className="heading">{t("configurePushNotifications")}</div>
          </div>
          <div className="empty-screen-container">
            <EmptyScreen
              img={Icons.userPref.noData}
              small={true}
              title={t("UserPref.noDataTitle")}
              desc={t("UserPref.noDataDescription")}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default UserPreferences;
